import { Tabs } from "antd";
import React from "react";
import Ereport from "./components/NE";
import Microwave from "./components/Microwave";
import MicrowaveFile from "./components/MicrowaveFile";
import Microwave_Coustom from "./components/Microwave_Coustom";
import PLA_Coustom from "./components/PLA_Coustom";
import CPU from "./components/CPU";
import ROUTER from "./components/ROUTER";
import PLA from "./components/PLA";
import LTP from "./components/LTP";
import G100 from "./components/G100";
import IG30028 from "./components/IG30028";
const { TabPane } = Tabs;

function callback(key) {
  console.log(key);
}

const Reports = () => {
  return (
    <div className="p-5">
      <Tabs
        defaultActiveKey="Microwave"
        onChange={callback}
        destroyInactiveTabPane={true}
      >
        <TabPane tab="Microwave" key="Microwave">
          <Microwave />
        </TabPane>
        <TabPane tab="Microwave Fix" key="Microwave_Fix">
          <Microwave_Coustom />
        </TabPane>
        <TabPane tab="Microwave File" key="Microwave_import">
          <MicrowaveFile />
        </TabPane>
        <TabPane tab="PLA" key="PLA">
          <PLA />
        </TabPane>
        <TabPane tab="PLA_Coustom" key="PLA_Coustom">
          <PLA_Coustom />
        </TabPane>
        <TabPane tab="LTP" key="LTP">
          <LTP />
        </TabPane>
        <TabPane tab="NE Report" key="NEReport">
          <Ereport />
        </TabPane>
        <TabPane tab="CPU" key="CPU">
          <CPU />
        </TabPane>
        <TabPane tab="ROUTER" key="ROUTER">
          <ROUTER />
        </TabPane>
        <TabPane tab="100G" key="100G">
          <G100 />
        </TabPane>
        <TabPane tab="RSL " key="RSL">
          <IG30028 />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default Reports;
